import { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../Layouts/AppLayout";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getSite, updateSite } from "../../api";
import { getFormPayload } from "../../utils";
import { useParams } from "react-router";
import { useSnackbar } from "notistack";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: "auto 8px !important",
  },
  form: {
    marginTop: theme.spacing(4),
  },
  input: {
    marginBottom: theme.spacing(2) + " !important",
  },
}));

export default function Edit() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { id } = useParams();
  const [site, setSite] = useState();

  const { data: siteData } = useQuery(["sites", id], getSite(id), {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  useEffect(() => {
    setSite(siteData);
  }, [siteData]);

  const {
    mutate: doUpdateSite,
    isLoading,
    error,
  } = useMutation(updateSite, {
    onSuccess: ({ message }) => {
      enqueueSnackbar(message, { variant: "success" });
      queryClient.invalidateQueries(["sites"]);
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const handleChange = (key) => (e) =>
    setSite({ ...site, [key]: e.target.value });

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const site = getFormPayload(e.currentTarget);
      doUpdateSite({ id, site });
    },
    [id, doUpdateSite]
  );

  const validationErrors = error && error.errors;

  return (
    <Layout>
      <Box display="flex">
        <Link to="/sites">
          <IconButton>
            <ArrowBack />
          </IconButton>
        </Link>
        <Typography variant="h5" className={classes.title}>
          Edit site
        </Typography>
      </Box>

      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <TextField
          name="name"
          className={classes.input}
          value={site?.name || ""}
          onChange={handleChange("name")}
          InputLabelProps={{ shrink: true }}
          label="Name"
          variant="outlined"
          fullWidth
          error={!!validationErrors?.name}
          helperText={validationErrors?.name}
        />

        <Button
          variant="contained"
          color="primary"
          type="submit"
          size="large"
          disabled={isLoading}
        >
          Submit
        </Button>
      </form>
    </Layout>
  );
}
